import AppBar from "@mui/material/AppBar";
import { Box } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { useProSidebar } from "react-pro-sidebar";
import { Link } from "react-router-dom";


const HeaderTop = () => {
  const { collapseSidebar } = useProSidebar();
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" sx={{ boxShadow: 0, bgcolor: "#fafafa" }}>
        <Toolbar>
          <IconButton
            onClick={() => collapseSidebar()}
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ mr: 2, color: "#AD1C86" }}
          >
            <MenuIcon />
          </IconButton>
          <Box display="flex" alignItems="center">
            <Link
              to="/dashboard"
              style={{
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
                color:"#065A79"
              }}
            >
             <b>Shree Mangalam School</b>
            </Link>
          </Box>
        </Toolbar>
      </AppBar>
          {/* <hr /> */}
    </Box>
  );
};

export default HeaderTop;

